import { render, staticRenderFns } from "./BeforeLoader.vue?vue&type=template&id=07db13b4&"
import script from "./BeforeLoader.vue?vue&type=script&lang=js&"
export * from "./BeforeLoader.vue?vue&type=script&lang=js&"
import style0 from "./BeforeLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports